// Copyright (c) 2016 Deere & Company

export const getAgGridLocaleText = () => ({
    // for filter panel
    page: 'Page',
    more: 'More',
    to: 'to',
    of: 'of',
    next: 'Next',
    last: 'Last',
    first: 'First',
    previous: 'Previous',
    loadingOoo: 'Loading...',

    // for set filter
    selectAll: 'Select All',
    searchOoo: 'Search...',
    blanks: 'Blanks',

    // for number filter and text filter
    filterOoo: 'Filter...',
    applyFilter: 'Apply Filter',
    equals: 'Equals',
    notEquals: 'Not equals',

    // for number filter
    lessThan: 'Less than',
    greaterThan: 'Greater than',
    lessThanOrEqual: 'Less than or equals',
    greaterThanOrEqual: 'Greater than or equals',
    inRange: 'In range',

    // for text filter
    contains: 'Contains',
    notContains: 'Not contains',
    startsWith: 'Starts with',
    endsWith: 'Ends with',

    // filter conditions
    andCondition: 'AND',
    orCondition: 'OR',

    // the header of the default group column
    group: 'Group',

    // tool panel
    columns: 'Columns',
    filters: 'Filters',
    rowGroupColumns: 'Row Groups',
    rowGroupColumnsEmptyMessage: 'Drag columns from above to group by them',
    valueColumns: 'Value Columns',
    pivotMode: 'Pivot Mode',
    groups: 'Groups',
    values: 'Values',
    pivots: 'Pivots',
    valueColumnsEmptyMessage: 'Drag columns from above to aggregate',
    pivotColumnsEmptyMessage: 'Drag here to set column labels',
    toolPanelButton: 'Tool Panel',

    // other
    noRowsToShow: 'No Rows To Show',
    enabled: 'Enabled',

    // enterprise menu
    pinColumn: 'Pin Column',
    valueAggregation: 'Value Aggregation',
    autosizeThiscolumn: 'Autosize This Column',
    autosizeAllColumns: 'Autosize All Columns',
    groupBy: 'Group by',
    ungroupBy: 'Un-Group by',
    resetColumns: 'Reset Columns',
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
    toolPanel: 'Tool Panel',
    export: 'Export',
    csvExport: 'CSV Export',
    excelExport: 'Excel Export',

    // enterprise menu pinning
    pinLeft: 'Pin Left',
    pinRight: 'Pin Right',
    noPin: 'No Pin',

    // enterprise menu aggregation and status bar
    sum: 'Sum',
    min: 'Min',
    max: 'Max',
    none: 'None',
    count: 'Count',
    avg: 'Average',
    filteredRows: 'Filtered',
    selectedRows: 'Selected',
    totalRows: 'Total Rows',
    totalAndFilteredRows: 'Rows',

    // standard menu
    copy: 'Copy',
    copyWithHeaders: 'Copy With Headers',
    ctrlC: 'ctrl n C',
    paste: 'Paste',
    ctrlV: 'ctrl n V',
});
